import {
  IAccountLicenceMutation,
  IAccountMutationForm,
} from 'services/accounts/types';
import { formatDateToISOUTC } from 'utils/global/date.utils';

export const accountFormToLicenceQuery = (
  accountForm: IAccountMutationForm
): IAccountLicenceMutation => {
  return {
    magellanAccountId: accountForm.id,

    license: {
      availableFrom: formatDateToISOUTC(accountForm.availableFrom),
      availableTo: accountForm.withEndDate
        ? formatDateToISOUTC(accountForm.availableTo)
        : null,
      firstName: accountForm.firstName,
      lastName: accountForm.lastName,
      fullName: accountForm.fullName,
      name: accountForm.name,
      email: accountForm.email,
      phoneNumberPrefix: accountForm.phoneNumberPrefix,
      phoneNumber: accountForm.phoneNumber,
      address: accountForm.address,
      taxOffice: accountForm.taxOffice,
      bankAccountNumber: accountForm.bankAccountNumber,
      bankName: accountForm.bankName,
      swift: accountForm.swift,
      companyId: accountForm.companyId,
      companyCountryAlfa2: accountForm.companyCountryAlfa2,
      availableServices: accountForm.availableServices,
      availableSettlementMethods: accountForm.availableSettlementMethods,
      availableStatementTemplates: accountForm.availableStatementTemplates,
      smartlinkDomains: accountForm.smartlinkDomains.map(d => ({
        id: d.id,
        name: d.name,
      })),
      defaultCurrencyId: accountForm.defaultCurrencyId,
      showOwnersLogoAsMain: accountForm.showOwnersLogoAsMain,
      deliveryCode: accountForm.deliveryCode,
      clientAccessModeId: accountForm.clientModuleAccess
        ? accountForm.clientAccessModeId
        : 0,
      isrcGenerationMode: accountForm.isrcGenerationMode ?? 1,
      clientModuleAccess: accountForm.clientModuleAccess,
      enableDigitalDelivery: accountForm.enableDigitalDelivery,
      isDemo: accountForm?.isDemo ?? false,
      demoModeId: accountForm?.isDemo ? accountForm?.demoModeId : null,
    },
  };
};
